module.exports = __webpack_public_path__ + "img/design-icon.783a913f.svg";